import { defineMessages } from 'react-intl';

export default defineMessages({
  emailAction: {
    description: 'returnLabelDispatcher.emailAction',
    defaultMessage: 'Authorize & Email',
    id: 'Cf+1PD',
  },
  downloadAction: {
    description: 'returnLabelDispatcher.downloadAction',
    defaultMessage: 'Download PDF',
    id: 'YRImlC',
  },
});
